import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const BadgeStatusPromo = ({ status }) => {
  const mappedStatus = status?.toLowerCase().replace(' ', '');
  const bgColor = () => {
    switch (status?.toLowerCase()) {
      case 'aktif':
        return '#E9FFF2';
      case 'dijadwalkan':
        return '#E7F1FF';
      case 'nonaktif':
        return '#FFF1F3';
      default:
        return '';
    }
  };
  return (
    <Box bgColor={bgColor()} className={styles['badge-status-promo__container']}>
      <TextRegular className={`${styles['badge-status-promo__text']} ${styles[`badge-status-promo__text--${mappedStatus}`]}`}>{status}</TextRegular>
    </Box>
  );
};

export default BadgeStatusPromo;
